<template>
  <div class="toast" v-show="isShow">{{ message }}</div>
</template>

<script>
export default {
  name: "Toast",
  components: {},
  props: {
  },
  data() {
    return {
      message: "",
      isShow: false,
    };
  },
  created() { },
  mounted() { },
  computed: {},
  methods: {
    show(message, duration = 1500) {
      console.log(11);
      this.isShow = true;
      this.message = message;
      setTimeout(() => {
        this.isShow = false;
        this.message = "";
      }, duration);
    },
  },
};
</script>
<style scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px 20px;
  color: #fff;
  /* background-color: rgba(0, 0, 0, 0.8); */
  background-color: #41424c;
  z-index: 9999;
  font-size: 0.85rem;
  border-radius: 5px;
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/components/common/toast/Toast.vue